import { Component, OnInit, Inject } from '@angular/core';
import { Globals } from '../../../../globals'
import { IepService } from "../../../../Services/IepService";
import { ISpedStudentDemographics } from '../../../../Models/ISpedStudentDemographics'
import { IIepInstance } from '../../../../Models/IIepInstance'
import { Message } from 'primeng/primeng';
import { ILockStatus } from '../../../../Models/ILockStatus';
import { Router } from "@angular/router";
import { LookupService } from 'src/app/Services/LookupService';
import { FormRevokingConsentService } from "../../../../Services/FormRevokingConsentService";
import { IFormRevokingConsent } from "../../../../Models/Forms/IFormRevokingConsent";
import { IReportParameter } from 'src/app/Models/IReportParameter';
import { SpinnerBase } from '../../../Base/SpinnerBase';
import { ReportService } from 'src/app/Services/ReportService';


@Component({
  selector: 'RevokingConsent',
  templateUrl: './RevokingConsent.component.html',
  styleUrls: ['./RevokingConsent.component.css']
})


export class FormRevokingConsentComponent extends SpinnerBase implements OnInit {
  
  _myGlobals: Globals;
  _baseUrl: string;
  _iepService: IepService;
  successMessages: Message[];
  errorMessages: Message[];
  studentInfo: ISpedStudentDemographics;
  selectedIepInstance: IIepInstance;
  isLocked: boolean;
  lockStatus: string;
  canEditIep: boolean;
  saveClicked: boolean;
  _lookupService: LookupService;
  formRevokingConsentDB: any = [];
  reportParamArray: IReportParameter[];
  //public showSpinner: boolean = false;

  constructor(
    private globals: Globals, reportService: ReportService,
    iepService: IepService,
    @Inject('BASE_URL') baseUrl: string,
    public router: Router,
    lookupService: LookupService,
    private _formRevokingConsentService: FormRevokingConsentService) {
      super(reportService);
    this._iepService = iepService;
    this._myGlobals = globals;
    this._baseUrl = baseUrl;
    this.studentInfo = this._myGlobals.spedStudentDemographics;
    this.selectedIepInstance = this._myGlobals.selectedIepInstance;
    this._lookupService = lookupService;
  }

  ngOnInit(): void {
    this.LoadFormRevokingConsentDetails();
    this.isLocked = false;
    this.canEditIep = this._myGlobals.canEdit();
    this.successMessages = [];
    this.errorMessages = [];

    this.scrollToTop();
  }

  LoadFormRevokingConsentDetails(): void {
    this._formRevokingConsentService.getFormRevokingConsent(this._myGlobals.selectedFormDetails.formId)
      .subscribe((res: IFormRevokingConsent) => {
        this.formRevokingConsentDB = res;
        this.formRevokingConsentDB.dateOfNotice = this.formRevokingConsentDB.dateOfNotice == null ? null : new Date(this.formRevokingConsentDB.dateOfNotice);
        this.formRevokingConsentDB.dateOn = this.formRevokingConsentDB.dateOn == null ? null : new Date(this.formRevokingConsentDB.dateOn);
        this.formRevokingConsentDB.endOfServicesDate = this.formRevokingConsentDB.endOfServicesDate == null ? null : new Date(this.formRevokingConsentDB.endOfServicesDate);
      },
        err => console.error(err)
      );
  }

  clearMessages() {
    this.successMessages = [];
    this.errorMessages = [];
  }

  addMessage(msg: Message) {
    if (msg.severity == 'error') {
      this.errorMessages = [...this.errorMessages, msg];
    }
    else {
      this.successMessages = [...this.successMessages, msg];
    }
  }

  loadUnLock(action) {
    this._iepService.lockUnlockForm(this._baseUrl + 'api/Iep/LockUnlockForm?formInstanceId='
      + this._myGlobals.selectedFormDetails.formInstanceId + '&action=' + action)
      .subscribe((res: ILockStatus) => {
        this.isLocked = res.success
        this.lockStatus = res.status
      },
        err => console.error(err)
      );
  }

  edit() {
    this.clearMessages();
    this.saveClicked = false;
    this._iepService.lockUnlockForm(this._baseUrl + 'api/Iep/LockUnlockForm?formInstanceId='
      + this._myGlobals.selectedFormDetails.formInstanceId + '&action=Lock')
      .subscribe((res: ILockStatus) => {
        this.isLocked = res.success
        this.lockStatus = res.status
        if (this.isLocked == true) {
          this.globals.editMode = true;
        }
        else {
          let failedMessage: Message = { severity: 'warn', summary: this.lockStatus }
          this.addMessage(failedMessage);
        }
      });
  }

  //Save the Revoking Consent
  save(action) {
    this.scrollToTop();
    this.clearMessages();
    this.saveClicked = true;

    //update values
    this._formRevokingConsentService.insertUpdateFormRevokingConsent(this.formRevokingConsentDB)
      .subscribe((res: IFormRevokingConsent) => {
        let successMessage: Message = { severity: 'success', summary: 'Record Saved Successfully', detail: res.id.toString() }
        this.addMessage(successMessage);
        if (action == 'Close') {
          this.globals.editMode = false;
          this.loadUnLock("UnLock");
        }
        this.saveClicked = false
        this.LoadFormRevokingConsentDetails();
      },
        (error) => {
          let errorMessage: Message = { severity: 'error', summary: 'Save Failed', detail: error };
          this.addMessage(errorMessage);
          this.saveClicked = false;
        }
      )

  }

  cancel() {
    this.clearMessages();
    this.globals.editMode = false;
    this.loadUnLock("UnLock");
    this.LoadFormRevokingConsentDetails();
  }

  populateReportParameters() {
    this.reportParamArray = [];
    this.reportParamArray.push(
      { parameterName: 'dtFrmEdited', parameterValue: this.formRevokingConsentDB.updatedOn.toString() },
      { parameterName: 'RequestID', parameterValue: '0' },
      { parameterName: 'isDraft', parameterValue: 'True' },
      { parameterName: 'FormInstanceID', parameterValue: this.formRevokingConsentDB.iepFormInstanceId.toString() },
      { parameterName: 'ShowCustomWaterMark', parameterValue: 'False' },
      { parameterName: 'CustomWatermarkText', parameterValue: 'DRAFT DRAFT DRAFT' },
      { parameterName: 'FormVersionID', parameterValue: '' },
      { parameterName: 'BlankForm', parameterValue: 'false' },
      { parameterName: 'IEPID', parameterValue: this.formRevokingConsentDB.iepId.toString()  },
      //{ parameterName: 'ReportPath', parameterValue: '' },
      { parameterName: 'isAssessment', parameterValue: 'False' }
    );
  }

  printEnglish() {
    this.populateReportParameters();
    this.printFormCommon(this.formRevokingConsentDB.rdlFileNameEnglish, this.reportParamArray);
  }

  printSpanish() {
    this.populateReportParameters();
    this.printFormCommon(this.formRevokingConsentDB.rdlFileNameSpanish, this.reportParamArray);
  }

}
